import { curry } from 'ramda';

export const actionCreatorFactory = curry((type, payload) => ({ type, payload }));
export const actionCreatorFactoryWithOpts = curry((type, payload, opts) => ({ type, payload, opts }));



// WEBPACK FOOTER //
// ./src/app/stores/actionCreatorFactory.js